import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/auth-store';

/** Avoid auth flicker before zustand persist rehydrates from localStorage. */
export function AuthHydrationGate({ children }) {
  const [ready, setReady] = useState(() => !!import.meta.env.VITEST);

  useEffect(() => {
    if (import.meta.env.VITEST) {
      return undefined;
    }
    const unsub = useAuthStore.persist.onFinishHydration(() => setReady(true));
    if (useAuthStore.persist.hasHydrated?.()) {
      setReady(true);
    }
    return unsub;
  }, []);

  if (!ready) {
    return null;
  }

  return children;
}
